import React from 'react';
import { Grid } from 'semantic-ui-react';

import BasicSectionLayout from './SectionLayout';
import SectionHeaderLayout from './SectionHeaderLayout';
import ProjectSectionLayout from "./SectionProjectLayout";

import { DataOfProjectsSection } from './data'

const FourthSection = () => {
  return (
    <BasicSectionLayout sectionClasse="projectSection" fluide={true}>

        <Grid.Column computer={10} tablet={14} mobile={16} textAlign="justified">

          <SectionHeaderLayout myhr={true}
            align ="center"
            title="Projects"
            headerclass="projectTitle bigTitle" 
          >
            <p className="paragraph padded__text" style={{marginBottom: 7 + 'rem'}}>
              IT is at the heart of digital and digitalization, just like current at the heart of electricity or the
              coil at the heart of the electric motor. It is both an educational tool and a science. As such, we can 
              therefore see that its influence on education is of considerable potential.
              As part of the activities of the FIPI program, the FIPI-Education Project has been set up and represents
              one of the main activities. Project which aims to allow young learners to find solutions adapted to local 
              realities. And all this using smart objects based on Arduino technology.
            </p>
          </SectionHeaderLayout>

        </Grid.Column>

            {
              DataOfProjectsSection.map((componentData, index) => {
                return (
                  <ProjectSectionLayout componentData={componentData} 
                    reverseOrder={ false }
                    key={`${componentData.objDescription.title}${index}`}
                  /> 
                );
              })
            }     

    </BasicSectionLayout>
  );
}

export default FourthSection;